export default "__VITE_ASSET__HhBY3Gnl__"